import api from '@/libs/axios'
import { TypeActionPreventionSanteTravail } from '../models/preventionSanteTravail/typeActionPreventionSanteTravail';
import { PaginatedList } from '../models/common/paginatedList'

const resource = 'TypesActionPreventionSanteTravail'

export default class TypesActionPreventionSanteTravailRessource {
  public async paginatedList(pagenumber?: number, pagesize?: number, actifOnly?: boolean): Promise<PaginatedList<TypeActionPreventionSanteTravail>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString());
    if (pagesize) params.append('PageSize', pagesize.toString());
    if (actifOnly) params.append('ActifOnly', actifOnly.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
